var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.796 19.807l-5.889-2.638-.016-.008a2 2 0 00-1.896.175 1 1 0 00-.094.07L16.86 20c-1.928-.936-3.918-2.912-4.854-4.814l2.597-3.089c.025-.031.05-.062.072-.096a2 2 0 00.165-1.883v-.014l-2.646-5.9a2 2 0 00-2.078-1.19A7.032 7.032 0 004 10c0 9.925 8.075 18 18 18a7.032 7.032 0 006.985-6.115 2 2 0 00-1.189-2.078zM22 26A16.017 16.017 0 016 10a5.025 5.025 0 014.359-5v.015l2.625 5.875-2.584 3.092a.77.77 0 00-.071.097 2 2 0 00-.125 1.962c1.132 2.316 3.466 4.633 5.807 5.764a2 2 0 001.969-.143 1.03 1.03 0 00.093-.07L21.11 19l5.875 2.631H27A5.026 5.026 0 0122 26z"
  })));
}
export default SvgPhoneRegular;